import { Doughnut } from "vue-chartjs";

export default {
  extends: Doughnut,
  props: ["data"],
  watch: {
    data: {
      handler: function(val, oldval) {
        this.renderChart(val.data, val.options);
      },
      deep: true //对象内部的属性监听，也叫深度监听
    }
  },
  mounted() {
    this.renderChart(this.data.data, this.data.options);
  }
};
